import { Component, type ErrorInfo, type ReactNode } from "react";
import { logger } from "@/shared/lib/logger";
import { reportBoundaryError } from "@/shared/lib/errorReporting";

/**
 * H5 入口级错误边界(audit-0713 C1a)。
 * advisor-h5 / wecom-h5 此前无任何 ErrorBoundary,渲染异常=整页白屏。
 * 不复用 PageErrorBoundary:其 FallbackUI 依赖 Router 上下文与 PC 主题 token,
 * 这里要在两套 H5 主题(advisor-dark / wecom-light)下都可读,且入口层可能在 Router 之外。
 */
export class H5ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    logger.error("H5 render error", {
      error: error.message,
      stack: error.stack,
      componentStack: info.componentStack ?? undefined,
    });
    reportBoundaryError(error, info.componentStack ?? undefined, "h5");
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100dvh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            padding: 24,
            textAlign: "center",
            fontSize: 14,
          }}
        >
          <div style={{ fontSize: 32 }} aria-hidden>
            ⚠️
          </div>
          <div style={{ fontWeight: 600 }}>页面出了点问题</div>
          <div style={{ opacity: 0.65, fontSize: 13 }}>刷新一下通常就能恢复</div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 8,
              padding: "8px 24px",
              borderRadius: 8,
              border: "1px solid currentColor",
              background: "transparent",
              color: "inherit",
              fontSize: 14,
            }}
          >
            刷新页面
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
